export class CustomParamsScheduleLookupModel {
  ScheduleOrganization: number;
  ScheduleGroup: number;
}
